import { css } from "@emotion/css"
import React from "react"

type Props = {
  children?: React.ReactNode
}

const SideBarLabel = ({ children }: Props) => {
  return <div className={style}>{children}</div>
}

export default SideBarLabel

const style = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 172px;
  height: 46px;
  padding: 0 8px;
  font-size: 14px;
  background-color: #edf5f0;
  border-radius: 10px;
`
